import { useCallback, useMemo } from 'react';
import useFetchReduxed from 'hooks/useFetchReduxed';
import { selectValidGBAccounts } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { getDefaultPaymentsAccount, setDefaultPaymentsAccount, } from '../actions';
export const useDefaultBankAccount = () => {
    const accounts = useAppSelector(selectValidGBAccounts);
    const [result, error, busy, fetch] = useFetchReduxed('payments');
    const defaultAccount = useMemo(() => {
        if (accounts && result) {
            return accounts.find((item) => item.sortCode === result.sortCode &&
                item.accountNumber === result.accountNumber);
        }
        return undefined;
    }, [accounts, result]);
    const defaultAccountFetch = useCallback(() => {
        if (!busy) {
            const now = new Date().getTime();
            if (!useDefaultBankAccount.lastCallTime ||
                now - useDefaultBankAccount.lastCallTime > 10 * 60 * 1000) {
                useDefaultBankAccount.lastCallTime = now;
                fetch(getDefaultPaymentsAccount());
            }
        }
    }, [busy]);
    const defaultAccountSet = useCallback((account) => {
        if (account) {
            fetch(setDefaultPaymentsAccount(account));
        }
    }, []);
    return [defaultAccount, error, busy, defaultAccountFetch, defaultAccountSet];
};
